import { type ETypeFavorite } from '@enums/TypeFavorite';
import { type Favorite } from '@models/Favorite';
import HttpClient from '@services/utils/HttpClient';

import { type IAddDrugToFavoritesInputData } from './dtos/addDrugToFavorites/InputData';
import { type IAddMajorAreaThemeToFavoritesInputData } from './dtos/addMajorAreaThemeToFavorites/InputData';
import { type IGetAllFavoritesOutputData } from './dtos/getAllFavorites/OutputData';
import { type IRemoveDrugFromFavoritesInputData } from './dtos/removeDrugFromFavorites/InputData';
import { type IRemoveMajorAreaThemeFromFavoritesInputData } from './dtos/removeMajorAreaThemeFromFavorites/InputData';
import { type IFavoriteRepository } from './IFavoriteRepository';

interface IAddDrugParams {
  id: number;
}

interface IAddMajorAreaThemeParams {
  id: number;
}

interface IGetAllResponse {
  lista: {
    id: number;
    nome: string;
    tipo: ETypeFavorite;
  }[];
}

interface IRemoveDrugParams {
  id: number;
}

interface IRemoveMajorAreaThemeParams {
  id: number;
}

class FavoriteService implements IFavoriteRepository {
  public async addDrug(inputData: IAddDrugToFavoritesInputData): Promise<void> {
    await HttpClient.put<unknown, unknown, IAddDrugParams>({
      path: 'medicamentofavorito.php',
      params: {
        id: inputData.id,
      },
    });
  }

  public async addMajorAreaTheme(
    inputData: IAddMajorAreaThemeToFavoritesInputData,
  ): Promise<void> {
    await HttpClient.put<unknown, unknown, IAddMajorAreaThemeParams>({
      path: 'temafavorito.php',
      params: {
        id: inputData.id,
      },
    });
  }

  public async getAll(): Promise<IGetAllFavoritesOutputData> {
    const response = await HttpClient.get<IGetAllResponse>({
      path: 'prescricaofavoritos.php',
    });
    const output: IGetAllFavoritesOutputData = {
      list: response.data.lista.map((item) => {
        const favorite: Favorite = {
          id: item.id,
          name: item.nome,
          type: item.tipo,
        };
        return favorite;
      }),
    };
    return output;
  }

  public async removeDrug(
    inputData: IRemoveDrugFromFavoritesInputData,
  ): Promise<void> {
    await HttpClient.delete<unknown, IRemoveDrugParams>({
      path: 'medicamentofavorito.php',
      params: {
        id: inputData.id,
      },
    });
  }

  public async removeMajorAreaTheme(
    inputData: IRemoveMajorAreaThemeFromFavoritesInputData,
  ): Promise<void> {
    await HttpClient.delete<unknown, IRemoveMajorAreaThemeParams>({
      path: 'temafavorito.php',
      params: {
        id: inputData.id,
      },
    });
  }
}

export default new FavoriteService();
